var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jump-item"},[_c('el-link',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.jumpToBreak(_vm.source)}}},[_vm._v("\n    "+_vm._s(_vm.source.transactionId)+" —\n    "+_vm._s(_vm.$dayjs(_vm.source.createdAt).format("DD.MM.YYYY HH:mm:ss"))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-474b3448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Ledger/components/FullBalance/LegacyGapItem.vue
// module id = null
// module chunks = 